export { shapeToPatterns } from './lib/shapeToPatterns.js';
export { constructQuery, deleteQuery, } from './lib/shapeToQuery.js';
export { default as s2q } from './ns.js';
export { default as PropertyShape } from './model/PropertyShape.js';
export { default as NodeShape } from './model/NodeShape.js';
